import { default as teacherPositionCategory } from './position-category/routes'

export default [
    ...teacherPositionCategory
]
